var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7322 9.61259C21.6422 9.69128 21.5522 9.76997 21.5522 9.75786C21.5522 4.38256 17.4242 0 12.3361 0C10.0321 0 7.9201 0.895884 6.28809 2.39709L7.8241 4.23729C9.02411 3.12349 10.6081 2.44552 12.3361 2.44552C16.1522 2.44552 19.2482 5.71428 19.2482 9.75786C19.2482 9.76997 19.1342 9.69128 19.0202 9.61259C18.9062 9.53389 18.7922 9.4552 18.7922 9.46731H16.7042L20.3762 13.7046L24.0002 9.46731H21.9122C21.9122 9.4552 21.8222 9.53389 21.7322 9.61259ZM2.26802 10.3874C2.35802 10.3087 2.44802 10.23 2.44802 10.2421C2.44802 15.6174 6.57605 20 11.6641 20C13.9681 20 16.0801 19.1041 17.7121 17.6029L16.1761 15.7627C14.9761 16.8765 13.3921 17.5545 11.6641 17.5545C7.84806 17.5545 4.75204 14.2857 4.75204 10.2421C4.75204 10.23 4.86604 10.3087 4.98004 10.3874C5.09404 10.4661 5.20804 10.5448 5.20804 10.5327H7.29606L3.62403 6.29541L0 10.5327H2.08802C2.08802 10.5448 2.17802 10.4661 2.26802 10.3874Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.e5ef737d.svg";
export { ForwardRef as ReactComponent };